module.exports = __webpack_public_path__ + "static/media/ofiaich.e2966137.png";